import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { BadgeScore } from './BadgeScore';

type Props = { score: number };
export const PetitionStrengthCard: React.FC<Props> = ({ score }) => {
	return (
		<div className="stroke-weaker bg-background-base elevation-low flex h-full min-h-[138px] w-[186px] flex-col gap-[11px] rounded-xl border p-5">
			<Text as="p" size="xx-small" variant="heading" className="lowercase first-letter:uppercase">
				<Translate value="corgi.petition.details.strength_score.title" />
			</Text>
			<BadgeScore
				score={score}
				sx={{
					'& #score-text': { fontSize: '14px' },
				}}
			/>
		</div>
	);
};
